angular
  .module('workflow')

  .directive('serviceForm', function() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'custom/workflow/views/partials/service.html',
      controller: 'ServiceCtrl'
    };
  });
